export const notificationTranslate = {
    es : {
        infoChargePayment: {
            title: "Este cambio tiene un cargo",
            subtitle : "El cargo se realizará a tu método de pago en tu siguiente cobro",
        },
        infoChargePaymentMethod: {
            title: "Este cambio tiene un cargo",
            subtitle : "El cargo se realizará de forma automática a tu método de pago",
        },
        successChangeSubscription: {
            title : ( date ) =>  `Cambios aplicarán a partir de ${date}` ,
            subtitle : "Solo puedes añadir acompañantes hasta 3 meses después de contratar Viva Fan",
        },

        expireMembership: ( date ) => { return `<strong> Renovación cancelada.</strong> <span class='font-light'> La renovación de tu membresía se canceló  ${ date } </span>` },

        
        errorChangeSubscription:{
            title: "No se puede realizar este cambio",
            subtitle : "No se puede realizar este cambio",
        },
        successBillingChange: {
            title: "Actualización exitosa",
            subtitle : "La información de pago se actualizó con éxito.",
        },
        companions: {
            change: {
                title:  `Cambios aplicarán a partir en tu siguiente renovación`,
                subtitle: 'Sólo puedes modificar a tus acompañantes hasta 3 meses después de contratar Viva Fan.'
            },
            CompanionLimitReached: {
                title: "Tu suscripción ha alcanzado el número máximo de acompañantes"

            },
            SubscriptionCanceled: {
                title: "Tu suscripción ha sido cancelada. No puedes añadir compañeros."
            },
            addCompanions: {
                title: 'Cambios realizados exitosamente',
                subtitle: 'Solo puedes añadir acompañantes hasta 3 meses después de contratar Viva Fan.'
            }
        },
        button: 'Suscribirme',
        buttonLogin: 'Ir al Dashboard',
        ENITMA_GENERIC_VALIDATION_ERROR: {
            title: 'Importante',
            content: `<p>Por favor verifica que los siguientes datos sean correctos:</p>
            <ul class='mt-3'>
            <li class='px-2'>RFC</li>
            <li class='px-2'>Nombre o razón social</li>
            <li class='px-2'>Clave de uso de CFDI</li>
            <li class='px-2'>Código postal</li>
            </ul>
            <p class='mt-3'>Los datos deben coincidir con la información registrada en tu constancia de identificación fiscal</p>`
        },
        ENITMA_ERROR: {
            title: 'Importante',
            content: `<p>Ha ocurrido un error, por favor comunícate a <a href="mailto:vivafan@vivaaerobus.com"> vivafan@vivaaerobus.com </a> para ayudarte </p>`
        },
    },
    eng : {
        successBillingChange: {
            title: "Update successful",
            subtitle : "The payment information was updated successfully.",
        },
        infoChargePayment: {
            title: "This change has a charge",
            subtitle : "The charge will be made to your next payment method in your next payment",
        },
        expireMembership: ( date ) => { return `<strong> Renewal canceled</strong> <span class='font-light'>  Your renewal is was canceled on ${ date } </span>`},

        infoChargePaymentMethod: {
            title: "This change has a charge",
            subtitle : "The charge will be made automatically to your payment method",
        },
        successChangeSubscription: {
            title : ( date ) =>  `Cannot make this change ${date}` ,
            subtitle : "Cannot make this change",
        },
        companions:{
            change: {
                title: 'Changes will apply starting with your next renewal.',
                subtitle: 'You can only modify your companions up to 3 months after contracting Viva Fan.'
            },
            CompanionLimitReached: {
                title: "Tu suscripción ha alcanzado el número máximo de acompañantes"
            },
            SubscriptionCanceled: {
                title: "Tu suscripción ha sido cancelada. No puedes añadir compañeros."
            },
            addCompanions: {
                title: 'Changes made successfully',
                subtitle: 'You can only add companions up to 3 months after contracting Viva Fan.'
            }
        },

        errorChangeSubscription:{
            title: "Changes will apply from DD/MM/YEAR",
            subtitle : "You can only add companions up to 3 months after the start of your subscription",
            },
        button: "Subscribe",
        buttonLogin : 'Go to Dashboard',
        ENITMA_GENERIC_VALIDATION_ERROR: {
            title: 'Important',
            content: `<p>Please verify that the following information is correct:</p>
            <ul class='mt-3'>
            <li class='px-2'>RFC</li>
            <li class='px-2'>Name</li>
            <li class='px-2'>CFDI use key</li>
            <li class='px-2'>Zip code</li>
            </ul>
            <p class='mt-3'>The data must match the information registered in your tax identification certificate</p>`
        },
        ENITMA_ERROR: {
            title: 'Important',
            content: `<p>An error has occurred, please contact <a href="mailto:vivafan@vivaaerobus.com"> vivafan@vivaaerobus.com </a> to help you</p>`
        },

        }
    }